import React from 'react';

import * as S from './styles';

const ModalBody: React.FC = ({ children, ...rest }) => {
  return <S.Body {...rest}>{children}</S.Body>;
};

export default ModalBody;
